import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const getFastBuyStatsV2 = async (context, startDate = null, endDate = null) => {
  const requestedApp = context?.activeApp;
  const isGroupContext = requestedApp === 'group_web';
  const groupId = isGroupContext
    ? context?.activeGroupId || context?.groupId
    : null;
  const operatingUnitId = !isGroupContext ? context?.activeUnitId : null;
  const dealershipId = !isGroupContext
    ? context?.dealershipId || context?.dealership
    : null;

  if (!['dealership_web', 'group_web'].includes(requestedApp)) {
    return { success: 'no', message: 'Contexto de aplicación inválido' };
  }
  if ((!isGroupContext && !operatingUnitId && !dealershipId) || (isGroupContext && !groupId)) {
    return { success: 'no', message: 'Contexto operativo incompleto' };
  }

  try {
    const getStatsFn = httpsCallable(functions, 'getFastBuyStatsV2');
    const result = await getStatsFn({
      groupId: groupId || undefined,
      operatingUnitId: operatingUnitId || undefined,
      dealershipId: dealershipId || undefined,
      requestedApp,
      startDate: startDate instanceof Date ? startDate.getTime() : null,
      endDate: endDate instanceof Date ? endDate.getTime() : null,
    });

    return result.data;
  } catch (error) {
    console.error('Error obteniendo estadísticas de fast buy:', error);
    notifyPermissionDenied(error);
    return { success: 'no', message: error.message };
  }
};
